/* eslint func-names: ["error", "never"] */
/* eslint no-underscore-dangle: ["error", { "allow": ["_data"] }] */
/* eslint-disable no-unused-vars */
/* global some_unused_var */

import Rails from '@rails/ujs';
import * as ActiveStorage from '@rails/activestorage';

import 'bootstrap';
import moment from 'moment';
import PerfectScrollbar from 'perfect-scrollbar';
import utils from '../components/utils';
import 'metismenu/dist/metisMenu';
import 'jquery-circle-progress';
import 'select2/dist/css/select2.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

// import * as StakeholderAnalytics from 'components/analytics';
import Store from '../store';

Rails.start();
ActiveStorage.start();

global.toastr = require('toastr');

global.store = Store;

global.moment = moment;
moment.locale('pt-br');

$(document).ready(() => {
  // StakeholderAnalytics.init();

  // Sidebar Menu
  setTimeout(() => {
    $('.vertical-nav-menu').metisMenu();
  }, 100);

  // Search wrapper trigger
  $('.search-icon').click(function () {
    $(this).parent().parent().addClass('active');
  });

  $('.search-wrapper .close').click(function () {
    $(this).parent().removeClass('active');
  });

  // BS4 Popover
  $('[data-toggle="popover-custom-content"]').each(function (i, obj) {
    $(this).popover({
      html: true,
      placement: 'auto',
      template:
        '<div class="popover popover-custom" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
      content() {
        const id = $(this).attr('popover-id');
        return $(`#popover-content-${id}`).html();
      },
    });
  });

  // Stop Bootstrap 4 Dropdown for closing on click inside
  $('.dropdown-menu').on('click', (event) => {
    let events = $._data(document, 'events') || {};

    events = events.click || [];

    for (let i = 0; i < events.length; i += 1) {
      if (events[i].selector) {
        if ($(event.target).is(events[i].selector)) {
          events[i].handler.call(event.target, event);
        }

        $(event.target)
          .parents(events[i].selector)
          .each(function () {
            events[i].handler.call(this, event);
          });
      }
    }
    event.stopPropagation(); // Always stop propagation
  });

  $('[data-toggle="popover-custom-bg"]').each(function (i, obj) {
    const popClass = $(this).attr('data-bg-class');

    $(this).popover({
      trigger: 'focus',
      placement: 'top',
      template:
        `<div class="popover popover-bg ${
          popClass
        }" role="tooltip"><h3 class="popover-header"></h3><div class="popover-body"></div></div>`,
    });
  });

  $(() => {
    $('[data-toggle="popover"]').popover();
  });

  $('[data-toggle="popover-custom"]').each(function (i, obj) {
    $(this).popover({
      html: true,
      container: false,
      content() {
        return $(this)
          .next('.rm-max-width')
          .find('.popover-custom-content')
          .html();
      },
    });
  });

  $('body').on('click', (e) => {
    $('[rel="popover-focus"]').each(function () {
      if (
        !$(this).is(e.target)
        && $(this).has(e.target).length === 0
        && $('.popover').has(e.target).length === 0
      ) {
        $(this).popover('hide');
      }
    });
  });

  $('.header-megamenu.nav > li > .nav-link').on('click', (e) => {
    $('[data-toggle="popover-custom"]').each(function () {
      if (
        !$(this).is(e.target)
        && $(this).has(e.target).length === 0
        && $('.popover').has(e.target).length === 0
      ) {
        $(this).popover('hide');
      }
    });
  });

  // BS4 Tooltips
  $(() => {
    $('[data-toggle="tooltip"]').tooltip();
  });

  $(() => {
    $('[data-toggle="tooltip-light"]').tooltip({
      template:
        '<div class="tooltip tooltip-light"><div class="tooltip-inner"></div></div>',
    });
  });

  // Drawer
  $('.open-right-drawer').click(function () {
    $(this).addClass('is-active');
    $('.app-drawer-wrapper').addClass('drawer-open');
    $('.app-drawer-overlay').removeClass('d-none');
  });

  $('.drawer-nav-btn').click(() => {
    $('.app-drawer-wrapper').removeClass('drawer-open');
    $('.app-drawer-overlay').addClass('d-none');
    $('.open-right-drawer').removeClass('is-active');
  });

  $('.app-drawer-overlay').click(function () {
    $(this).addClass('d-none');
    $('.app-drawer-wrapper').removeClass('drawer-open');
    $('.open-right-drawer').removeClass('is-active');
  });

  $('.mobile-toggle-nav').click(function () {
    $(this).toggleClass('is-active');
    $('.app-container').toggleClass('sidebar-mobile-open');
  });

  $('.mobile-toggle-header-nav').click(function () {
    $(this).toggleClass('active');
    $('.app-header__content').toggleClass('header-mobile-open');
  });

  $('.mobile-app-menu-btn').click(function () {
    $('.hamburger', this).toggleClass('is-active');
    $('.app-inner-layout').toggleClass('open-mobile-menu');
  });

  // Responsive

  const resizeClass = function () {
    const win = document.body.clientWidth;

    if (win < 1250) {
      $('.app-container').addClass('closed-sidebar-mobile closed-sidebar');
    } else {
      $('.app-container').removeClass('closed-sidebar-mobile closed-sidebar');
    }
  };

  $(window).on('resize', () => {
    resizeClass();
  });

  $('.close-sidebar-btn').click(function () {
    const classToSwitch = $(this).attr('data-class');
    const containerElement = '.app-container';
    $(containerElement).toggleClass(classToSwitch);

    const closeBtn = $(this);

    if (closeBtn.hasClass('is-active')) {
      closeBtn.removeClass('is-active');
    } else {
      closeBtn.addClass('is-active');
    }
  });

  $('.switch-container-class').on('click', function () {
    const classToSwitch = $(this).attr('data-class');
    const containerElement = '.app-container';
    $(containerElement).toggleClass(classToSwitch);

    $(this).parent().find('.switch-container-class').removeClass('active');
    $(this).addClass('active');
  });

  $('.switch-theme-class').on('click', function () {
    const classToSwitch = $(this).attr('data-class');
    const containerElement = '.app-container';

    if (classToSwitch === 'app-theme-white') {
      $(containerElement).removeClass('app-theme-gray');
      $(containerElement).addClass(classToSwitch);
    }

    if (classToSwitch === 'app-theme-gray') {
      $(containerElement).removeClass('app-theme-white');
      $(containerElement).addClass(classToSwitch);
    }

    if (classToSwitch === 'body-tabs-line') {
      $(containerElement).removeClass('body-tabs-shadow');
      $(containerElement).addClass(classToSwitch);
    }

    if (classToSwitch === 'body-tabs-shadow') {
      $(containerElement).removeClass('body-tabs-line');
      $(containerElement).addClass(classToSwitch);
    }

    $(this).parent().find('.switch-theme-class').removeClass('active');
    $(this).addClass('active');
  });

  $('.switch-header-cs-class').on('click', function () {
    const classToSwitch = $(this).attr('data-class');
    const containerElement = '.app-header';

    $('.switch-header-cs-class').removeClass('active');
    $(this).addClass('active');

    $(containerElement).attr('class', 'app-header');
    $(containerElement).addClass(`header-shadow ${classToSwitch}`);
  });

  $('.switch-sidebar-cs-class').on('click', function () {
    const classToSwitch = $(this).attr('data-class');
    const containerElement = '.app-sidebar';

    $('.switch-sidebar-cs-class').removeClass('active');
    $(this).addClass('active');

    $(containerElement).attr('class', 'app-sidebar');
    $(containerElement).addClass(`sidebar-shadow ${classToSwitch}`);
  });

  setTimeout(() => {
    // console.log($('.scrollbar-container2'))
    if ($('.scrollbar-container')[0]) {
      $('.scrollbar-container').each(function () {
        const ps = new PerfectScrollbar($(this)[0], {
          wheelSpeed: 2,
          wheelPropagation: false,
          minScrollbarLength: 10,
          useBothWheelAxes: true,
        });
      });

      // const ps = new PerfectScrollbar('.scrollbar-sidebar', {
      //   wheelSpeed: 2,
      //   wheelPropagation: true,
      //   minScrollbarLength: 20,
      // });
    }
  }, 1000);

  resizeClass();
});

// Reactjs setup
const componentRequireContext = require.context('components', true);
const ReactRailsUJS = require('react_ujs');

ReactRailsUJS.useContext(componentRequireContext);
